import { ChevronDown } from 'lucide-react'
import * as React from 'react'

import { cn } from '@/utils/cn'

// Thin wrapper around a native <select> that hides the browser's default arrow
// (whose right margin can't be controlled) and renders a chevron with proper
// spacing, so dropdown fields match the rest of the form styling.
export const NativeSelect = React.forwardRef<
  HTMLSelectElement,
  React.SelectHTMLAttributes<HTMLSelectElement>
>(({ className, children, ...props }, ref) => (
  <div className="relative">
    <select
      ref={ref}
      className={cn(
        'w-full appearance-none rounded-xl border border-border bg-white py-3 pl-3 pr-10 text-sm',
        className
      )}
      {...props}
    >
      {children}
    </select>
    <ChevronDown
      size={16}
      className="pointer-events-none absolute right-3 top-1/2 -translate-y-1/2 text-muted-foreground"
    />
  </div>
))
NativeSelect.displayName = 'NativeSelect'
